var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconRotateRightComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-rotate-right ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.921 2.69855L8.51769 0.961882C8.38436 0.868549 8.20103 0.961882 8.20103 1.12522V2.16522H6.86769C4.07103 2.16522 1.80103 4.43522 1.80103 7.23188V9.23188C1.80103 9.41855 1.95103 9.56522 2.13436 9.56522H2.93436C3.11769 9.56522 3.26769 9.41855 3.26769 9.23188V7.23188C3.26769 5.24522 4.88103 3.63188 6.86769 3.63188H8.20103V4.67522C8.20103 4.83855 8.38436 4.93522 8.51769 4.83855L10.921 3.10522C11.0577 3.00522 11.0577 2.79855 10.921 2.69855ZM6.5341 5.74398C5.61362 5.74398 4.86743 6.49017 4.86743 7.41064V13.4087C4.86743 14.3292 5.61362 15.0754 6.5341 15.0754H12.5321C13.4526 15.0754 14.1988 14.3292 14.1988 13.4087V7.41064C14.1988 6.49017 13.4526 5.74398 12.5321 5.74398H6.5341ZM6.20076 7.41064C6.20076 7.22655 6.35 7.07731 6.5341 7.07731H12.5321C12.7162 7.07731 12.8655 7.22655 12.8655 7.41064V13.4087C12.8655 13.5928 12.7162 13.742 12.5321 13.742H6.5341C6.35 13.742 6.20076 13.5928 6.20076 13.4087V7.41064Z",
    fillOpacity: "1"
  }));
}
var IconRotateRight = /*#__PURE__*/React.forwardRef(IconRotateRightComponent);
export default IconRotateRight;